import { ref } from 'vue'
import { useRouter } from 'vue-router'

// 标签页数据结构（模块级单例；切换账号必须 reset，否则会残留上一账号页签）
const tabs = ref([])
const activeTab = ref('')

/** 退出登录 / 切换账号时调用（store.clearUser 也会调） */
export function resetAppTabs () {
  tabs.value = []
  activeTab.value = ''
}

export function useTabs() {
  const router = useRouter()

  // 添加标签页
  const addTab = (route) => {
    const { path, name, meta } = route
    
    // 如果标签页已存在，直接激活（不重复跳转路由）
    const existingTab = tabs.value.find(tab => tab.path === path)
    if (existingTab) {
      activeTab.value = path
      return
    }

    // 创建新标签页
    const newTab = {
      path,
      name: name || path,
      title: meta?.title || path,
      closable: path !== '/dashboard' // 首页不可关闭
    }

    tabs.value.push(newTab)
    activeTab.value = path
  }

  const _normPath = (p) => {
    if (!p) return ''
    const s = String(p)
    return s.length > 1 && s.endsWith('/') ? s.slice(0, -1) : s
  }

  // 移除标签页（支持「路由已先跳到其它页」再关旧标签：如从订单去客户页再返回订单后关客户标签）
  const removeTab = (targetPath) => {
    if (!targetPath || targetPath === '/dashboard') return

    const tp = _normPath(targetPath)
    const index = tabs.value.findIndex((tab) => _normPath(tab.path) === tp)
    if (index === -1) return

    tabs.value.splice(index, 1)

    const currentPath = _normPath(router.currentRoute.value.path)
    if (tabs.value.some((t) => _normPath(t.path) === currentPath)) {
      activeTab.value = router.currentRoute.value.path
      return
    }

    // 当前浏览器路由对应的标签已不存在：切到相邻标签
    const next = tabs.value[index] || tabs.value[index - 1]
    if (next) {
      activeTab.value = next.path
      router.push(next.path)
    } else {
      activeTab.value = '/dashboard'
      router.push('/dashboard')
    }
  }

  // 关闭其他标签页
  const closeOthers = (currentPath) => {
    tabs.value = tabs.value.filter(tab => 
      tab.path === currentPath || tab.path === '/dashboard'
    )
  }

  // 关闭所有标签页
  const closeAll = () => {
    tabs.value = tabs.value.filter(tab => tab.path === '/dashboard')
    activeTab.value = '/dashboard'
    router.push('/dashboard')
  }

  /** 退出/切换账号时清空标签（否则上一账号打开的「用户权限管理」等页签会残留） */
  const resetTabs = () => {
    resetAppTabs()
  }

  // 初始化首页标签
  const initTabs = () => {
    if (tabs.value.length === 0) {
      tabs.value.push({
        path: '/dashboard',
        name: 'Dashboard',
        title: '系统首页',
        closable: false
      })
      activeTab.value = '/dashboard'
    }
  }

  return {
    tabs,
    activeTab,
    addTab,
    removeTab,
    closeOthers,
    closeAll,
    resetTabs,
    initTabs
  }
}

